exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2r-EVQpU74WZM6uBy1DNB-{width:300px}html[dir] ._2r-EVQpU74WZM6uBy1DNB-{background-color:\"[theme:white, default:#ffffff]\"}._3L14wHa9KFsnr-eCw4C-HW{max-height:470px;overflow-x:hidden}._1SPyxWsa3vKVgoJ9BVaO0H{height:30px}html[dir=ltr] ._1SPyxWsa3vKVgoJ9BVaO0H{padding-left:12px}html[dir=rtl] ._1SPyxWsa3vKVgoJ9BVaO0H{padding-right:12px}._3QUA55ujQqxG38mUr-nDCY{font-size:12px;font-weight:600;line-height:1;display:inline-block}html[dir] ._3QUA55ujQqxG38mUr-nDCY{padding-top:8px}", ""]);
// Exports
exports.locals = {
	"callout": "_2r-EVQpU74WZM6uBy1DNB-",
	"scrollContainer": "_3L14wHa9KFsnr-eCw4C-HW",
	"suggestedContactsHeaderBox": "_1SPyxWsa3vKVgoJ9BVaO0H",
	"suggestedContactsText": "_3QUA55ujQqxG38mUr-nDCY"
};